import React from "react";
import ReacDOM from "react-dom"
import App from "./App";
const root=ReacDOM.createRoot(document.getElementById('root'))

root.render(
    <>
        <App/>
    </>
)